import { _ as _asyncToGenerator, a as _regeneratorRuntime } from '../../../dist/asyncToGenerator-c002e3ca.esm.js';
import { _ as _inherits, a as _createSuper, b as _classCallCheck, d as _defineProperty, e as _assertThisInitialized, c as _createClass } from '../../../dist/createClass-3115abc1.esm.js';
import { _ as _wrapNativeSuper } from '../../../dist/wrapNativeSuper-76ffa30e.esm.js';
import { success } from '@lens-protocol/shared-kernel';
import { L as LogoutReason } from '../../../dist/ILogoutPresenter-c7a8a33e.esm.js';

var CredentialsExpiredError = /*#__PURE__*/function (_Error) {
  _inherits(CredentialsExpiredError, _Error);
  var _super = _createSuper(CredentialsExpiredError);
  function CredentialsExpiredError() {
    var _this;
    _classCallCheck(this, CredentialsExpiredError);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "name", 'CredentialsExpiredError');
    _defineProperty(_assertThisInitialized(_this), "message", 'Auth credentials are expired');
    return _this;
  }
  return _createClass(CredentialsExpiredError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
var Bootstrap = /*#__PURE__*/function () {
  function Bootstrap(activeWallet, credentialsGateway, credentialsRenewer, activeWalletPresenter, applicationPresenter, logoutPresenter, activeProfileLoader, transactionQueue, activeProfileGateway) {
    _classCallCheck(this, Bootstrap);
    this.activeWallet = activeWallet;
    this.credentialsGateway = credentialsGateway;
    this.credentialsRenewer = credentialsRenewer;
    this.activeWalletPresenter = activeWalletPresenter;
    this.applicationPresenter = applicationPresenter;
    this.logoutPresenter = logoutPresenter;
    this.activeProfileLoader = activeProfileLoader;
    this.transactionQueue = transactionQueue;
    this.activeProfileGateway = activeProfileGateway;
  }
  _createClass(Bootstrap, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var wallet, credentials, result, newCredentials;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.activeWallet.getActiveWallet();
            case 2:
              wallet = _context.sent;
              if (wallet) {
                _context.next = 6;
                break;
              }
              this.applicationPresenter.signalReady();
              return _context.abrupt("return");
            case 6:
              _context.next = 8;
              return this.credentialsGateway.getCredentials();
            case 8:
              credentials = _context.sent;
              if (credentials) {
                _context.next = 13;
                break;
              }
              _context.next = 12;
              return this.startWithExpCredentials(wallet);
            case 12:
              return _context.abrupt("return");
            case 13:
              _context.next = 15;
              return this.credentialsRenewer.renewCredentials(credentials);
            case 15:
              result = _context.sent;
              if (!result.isFailure()) {
                _context.next = 20;
                break;
              }
              _context.next = 19;
              return this.startWithExpCredentials(wallet);
            case 19:
              return _context.abrupt("return");
            case 20:
              newCredentials = result.unwrap();
              _context.next = 23;
              return this.credentialsGateway.save(newCredentials);
            case 23:
              _context.next = 25;
              return this.startWithCredentials(wallet);
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function start() {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "startWithCredentials",
    value: function () {
      var _startWithCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(wallet) {
        var activeProfile, handle;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.activeWalletPresenter.presentActiveWallet(wallet);
              _context2.next = 3;
              return this.activeProfileGateway.getActiveProfile();
            case 3:
              activeProfile = _context2.sent;
              handle = activeProfile === null || activeProfile === void 0 ? void 0 : activeProfile.handle;
              _context2.next = 7;
              return this.activeProfileLoader.loadActiveProfileByOwnerAddress(wallet.address, handle);
            case 7:
              _context2.next = 9;
              return this.transactionQueue.init();
            case 9:
              this.applicationPresenter.signalReady();
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function startWithCredentials(_x) {
        return _startWithCredentials.apply(this, arguments);
      }
      return startWithCredentials;
    }()
  }, {
    key: "startWithExpCredentials",
    value: function () {
      var _startWithExpCredentials = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(wallet) {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.logoutPresenter.present(success({
                lastLoggedInWallet: wallet,
                logoutReason: LogoutReason.CREDENTIALS_EXPIRED
              }));
              this.applicationPresenter.signalReady();
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function startWithExpCredentials(_x2) {
        return _startWithExpCredentials.apply(this, arguments);
      }
      return startWithExpCredentials;
    }()
  }]);
  return Bootstrap;
}();

export { Bootstrap, CredentialsExpiredError };
